import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import HeatStrip from '@/pages/home/components/HeatStrip';
import FocusSection from '@/pages/home/components/FocusSection';
import ThreadSection from '@/pages/home/components/ThreadSection';
import RankingSection from '@/pages/home/components/RankingSection';
import FeedSection from '@/pages/home/components/FeedSection';
import SubmitSection from '@/pages/home/components/SubmitSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <HeatStrip />
        <FocusSection />
        <ThreadSection />
        <RankingSection />
        <FeedSection />
        <SubmitSection />
      </main>
      <Footer />
    </div>
  );
}